import { render, staticRenderFns } from "./AgreementUser.vue?vue&type=template&id=3ed5c80e&scoped=true&"
import script from "./AgreementUser.vue?vue&type=script&lang=js&"
export * from "./AgreementUser.vue?vue&type=script&lang=js&"
import style0 from "./AgreementUser.vue?vue&type=style&index=0&id=3ed5c80e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed5c80e",
  null
  
)

export default component.exports